export type ClassValue = string | false | null | undefined

// Join nonempty class names without merging utilities.
export function cx(...values: readonly ClassValue[]): string {
  return values.filter((value): value is string => Boolean(value)).join(' ')
}
